import {WEBP_URL_SUFFIX} from '../../../../components/HbImage/imageConstants';

export const getBannerPreloadImages = ({banner, preloadRetinaImages}) => {
  const {image1x = '', image2x = ''} = banner || {};

  if (image1x?.includes(WEBP_URL_SUFFIX) && image2x?.includes(WEBP_URL_SUFFIX)) {
    let webp = `${image1x} 1x`

    if (preloadRetinaImages) {
      webp += `, ${image2x} 2x`
    }

    return [{
      webp,
      png: `${image1x?.replace(WEBP_URL_SUFFIX, '')}`
    }]
  }

  if (image1x) {
    return [{
      png: `${image1x?.replace(WEBP_URL_SUFFIX, '')}`
    }]
  }

  return [];
}
